import EventEmitter from 'events';

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const userlogin = 'islogged';
const loginExpiryKey = 'tokenExpiry';
const Userinfo = 'userinfo';

/*const state = {
    data: MainMenu.data
}*/

class Auth extends EventEmitter {

    /*localLogin(response) {

        this.tokenExpiry = new Date();
        localStorage.setItem(loginExpiryKey, this.tokenExpiry);
        localStorage.setItem(userlogin, 'true');
        localStorage.setItem(Userinfo, JSON.stringify({
            displayName : authResult.user.displayName,
            email : authResult.user.email,
            photoURL : authResult.user.photoURL,
        }));

    }*/

    /*Logout() {
        localStorage.removeItem(loginExpiryKey);
        localStorage.removeItem(userlogin);
        localStorage.removeItem(Userinfo);
    }*/

    isAuthenticated() {
        return (
            localStorage.signedIn?true:false

            //new Date(Date.now()) !=  new Date(localStorage.getItem(loginExpiryKey)) &&
            //localStorage.getItem(userlogin) === 'true'
        );
    }

    isAuthenticatedFor (to) {

        //console.log(to)

        return (
    
            localStorage.signedIn?true:false

            //new Date(Date.now()) !=  new Date(localStorage.getItem(loginExpiryKey)) &&
            //localStorage.getItem(userlogin) === 'true'
        );
    }

    cargarMenu (main_menu) {

        // limpio el menu
        main_menu.splice(0, main_menu.length) 

        //var environment_name = localStorage.environment_name //esto lo agrego para saber si cambio el nombre de Empresa a Grupo de Trabajo

        if (localStorage.accesos != undefined) {

            //console.log(localStorage.accesos);

            //main_menu.push({ order: 0, title: "Dashboard", icon: "pie-chart", type: "sub", path: "/dashboard/billing", active: false })
            main_menu.push({ order: 1, title: "Casos", icon: "inbox", type: "sub", path: "/case/list", active: false })
            //main_menu.push({ order: 4, title: "Facturas", icon: "file", type: "sub", path: "/invoice/list", active: false })
            //main_menu.push({ order: 5, title: "Clientes", icon: "users", type: "sub", path: "/project_client/list", active: false })
            //main_menu.push({ order: 6, title: "Contactos", icon: "user", type: "sub", path: "/contact/list", active: false })
            //main_menu.push({ order: 2, title: "Proyectos", icon: "command", type: "sub", path: "/project/list", active: false })
            //main_menu.push({ order: 3, title: "Infraestructura", icon: "server", type: "sub", path: "/infra/list", active: false })
            //main_menu.push({ order: 7, title: "Servicios", icon: "grid", type: "sub", path: "/service/list", active: false })
            //main_menu.push({ order: 8, title: "Reportes", icon: "bar-chart-2", type: "sub", path: "/report/list", active: false })
            //main_menu.push({ order: 9, title: "Ajustes", icon: "settings", type: "sub", path: "/settings/list", active: false })
            
            main_menu.sort(function(a, b){ return a.order-b.order })

            /*if (false) {
                menu.push({
                    "order": 999, "title": "Dashboard", "icon": "home", "type": "sub", "badgeType": "primary", "badgeValue": "6", "active": false, "children": [
                    { "order": 999,"path": "/dashboard/default2", "title": "Default", "type": "link" },          
                    { "order": 999,"path": "/dashboard/ecommerce", "title": "E-Commerce", "type": "link" },
                    { "order": 999,"path": "/dashboard/university", "title": "University", "type": "link" },         
                    { "order": 999,"path": "/dashboard/bitcoin", "title": "Crypto", "type": "link" },
                    { "order": 999,"path": "/dashboard/server", "title": "Server", "type": "link" },      
                    { "order": 999,"path": "/dashboard/project", "title": "Project", "type": "link" }
                    ]
                });
                
                menu.push({
                    "order": 999,"title": "Widgets", "icon": "airplay", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/widgets/general", "title": "General", "type": "link" },
                    { "order": 999,"path": "/widgets/chart", "title": "Chart", "type": "link" }
                    ]
                })
                
                menu.push({
                    "order": 999,"title": "Base", "icon": "box", "type": "sub", "active": false, "children": [
                        { "order": 999,"path": "/base/state-color", "title": "State Color", "type": "link" },          
                        { "order": 999,"path": "/base/typography", "title": "Typography", "type": "link" },          
                        { "order": 999,"path": "/base/avatars", "title": "Avatars", "type": "link" },          
                        { "order": 999,"path": "/base/helper-classes", "title": "Helper Classes", "type": "link" },          
                        { "order": 999,"path": "/base/grid", "title": "Grid", "type": "link" },         
                        { "order": 999,"path": "/base/tag-pills", "title": "Tag & Pills", "type": "link" },         
                        { "order": 999,"path": "/base/progress-bar", "title": "Progressbar", "type": "link" },         
                        { "order": 999,"path": "/base/modal", "title": "Modal", "type": "link" },        
                        { "order": 999,"path": "/base/alert", "title": "Alert", "type": "link" },        
                        { "order": 999,"path": "/base/popover", "title": "Popover", "type": "link" },       
                        { "order": 999,"path": "/base/tooltip", "title": "Tooltip", "type": "link" },       
                        { "order": 999,"path": "/base/loader", "title": "Spinners", "type": "link" },       
                        { "order": 999,"path": "/base/dropdown", "title": "Dropdown", "type": "link" },       
                        { "order": 999,"path": "/base/accordion", "title": "Accordian", "type": "link" },       
                        { "order": 999,"path": "/base/navs", "title": "Navs", "type": "link" },       
                        { "order": 999,"path": "/base/box-shadow", "title": "Shadow", "type": "link" },
                        { "order": 999,"path": "/base/lists", "title": "Lists", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Advance", "icon": "folder-plus", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/advance/scrollable", "title": "Scrollable", "type": "link" },   
                    { "order": 999,"path": "/advance/toastr", "title": "Toaster", "type": "link" },
                    { "order": 999,"path": "/advance/tour", "title": "Tour", "type": "link" },        
                    { "order": 999,"path": "/advance/rating", "title": "Rating", "type": "link" },        
                    { "order": 999,"path": "/advance/pagination", "title": "Pagination", "type": "link" },        
                    { "order": 999,"path": "/advance/sweetalert", "title": "SweetAlert", "type": "link" },              
                    { "order": 999,"path": "/advance/ribbons", "title": "Ribbons", "type": "link" },        
                    { "order": 999,"path": "/advance/steps", "title": "Steps", "type": "link" },            
                    { "order": 999,"path": "/advance/range-slider", "title": "Range Slider", "type": "link" },           
                    { "order": 999,"path": "/advance/image-cropper", "title": "Image Cropper", "type": "link" },           
                    { "order": 999,"path": "/advance/upload", "title": "Upload", "type": "link" },      
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Icons", "icon": "command", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/icons/flag", "title": "Flag icon", "type": "link" },          
                    { "order": 999,"path": "/icons/fontawesome", "title": "Fontawesome Icon", "type": "link" },          
                    { "order": 999,"path": "/icons/ico", "title": "Ico Icon", "type": "link" },          
                    { "order": 999,"path": "/icons/themify", "title": "Themify Icon", "type": "link" },          
                    { "order": 999,"path": "/icons/feather_icon", "title": "Feather Icon", "type": "link" },
                    { "order": 999,"path": "/icons/whether", "title": "Whether Icon", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Buttons", "icon": "cloud", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/buttons/default", "title": "Default Style", "type": "link" },          
                    { "order": 999,"path": "/buttons/flat", "title": "Flat Style", "type": "link" },          
                    { "order": 999,"path": "/buttons/edge", "title": "Edge Style", "type": "link" },          
                    { "order": 999,"path": "/buttons/raised", "title": "Raised Style", "type": "link" },          
                    { "order": 999,"path": "/buttons/group", "title": "Button Group", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Forms", "icon": "file-text", "type": "sub", "active": false, "children": [
                    { "order": 999,"title": "Form Controls", "type": "sub", "active": false, "children": [
                        { "order": 999,"path": "/form/validation", "title": "Form Validation", "type": "link" },          
                        { "order": 999,"path": "/form/inputs", "title": "Base Inputs", "type": "link" },          
                        { "order": 999,"path": "/form/checkbox-radio", "title": "Checkbox & Radio", "type": "link" },          
                        { "order": 999,"path": "/form/input-groups", "title": "Input Groups", "type": "link" },
                        { "order": 999,"path": "/form/mega-options", "title": "Mega Options", "type": "link" }
                    ]},
                    { "order": 999,"title": "Form Widgets", "type": "sub", "active": false, "children": [
                        { "order": 999,"path": "/form/datepicker", "title": "Datepicker", "type": "link" },
                        { "order": 999,"path": "/form/select2", "title": "Select2", "type": "link" },
                        { "order": 999,"path": "/form/switch", "title": "Switch", "type": "link" },
                        { "order": 999,"path": "/form/touchspin", "title": "Touchspin", "type": "link" },
                        { "order": 999,"path": "/form/typeahead", "title": "Typeahead", "type": "link" },
                        { "order": 999,"path": "/form/clipboard", "title": "Clipboard", "type": "link" }
                    ]},
                    { "order": 999,"path": "/form/wizard", "title": "Form Wizard", "type": "link" }      
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Tables", "icon": "server", "type": "sub", "active": false, "children": [
                    { "order": 999,"title": "Bootstrap Tables", "type": "sub", "active": false, "children": [
                        { "order": 999,"path": "/table/basic", "title": "Basic Tables", "type": "link" },          
                        { "order": 999,"path": "/table/sizing", "title": "Sizing Tables", "type": "link" },          
                        { "order": 999,"path": "/table/border", "title": "Border Tables", "type": "link" },          
                        { "order": 999,"path": "/table/styling", "title": "Styling Tables", "type": "link" }
                    ]},
                    { "order": 999,"title": "Data Tables", "type": "sub", "active": false, "children": [
                        { "order": 999,"path": "/datatable-basic", "title": "Basic Init", "type": "link" },
                        { "order": 999,"path": "/datatable-select-delete", "title": "Select Delete", "type": "link" },
                        { "order": 999,"path": "/filter-table", "title": "Filter", "type": "link" },
                        { "order": 999,"path": "/datatable-export", "title": "Data Export", "type": "link" }
                    ]},
                    { "order": 999,"path": "/table/smarttable", "title": "VueJs Smart Table", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999, "title": "Gallery", "icon": "image", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/gallery/grid-gallery", "title": "Grid Gallery", "type": "link" },
                    { "order": 999,"path": "/gallery/gallery-desc", "title": "Grid Gallery With Desc", "type": "link" },
                    { "order": 999,"path": "/gallery/gallery-masonary", "title": "Masonary Gallery", "type": "link" },
                    { "order": 999,"path": "/gallery/gallery-masonary-desc", "title": "Masonary Gallery Desc", "type": "link" },
                    { "order": 999,"path": "/gallery/hover-effect", "title": "Hover Effect", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Cards", "icon": "book", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/cards/basic", "title": "Basic Card", "type": "link" },          
                    { "order": 999,"path": "/cards/creative", "title": "Creative Card", "type": "link" },          
                    { "order": 999,"path": "/cards/tabbed", "title": "Tabbed Card", "type": "link" },          
                    { "order": 999,"path": "/cards/draggable", "title": "Draggable Card", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Timeline", "icon": "sliders", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/timeline/one", "title": "Timeline 1", "type": "link" },
                    { "order": 999,"path": "/timeline/two", "title": "Timeline 2", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Charts", "icon": "bar-chart", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/chart/google", "title": "Google Chart", "type": "link" },          
                    { "order": 999,"path": "/chart/chartjs", "title": "Chartjs", "type": "link" },
                    { "order": 999,"path": "/chart/chartist", "title": "Chartist", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Maps", "icon": "map", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/maps/vue-google-maps", "title": "Google Maps", "type": "link" },
                    { "order": 999,"path": "/maps/vue-leaflet-maps", "title": "Vue Leaflet", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "editor", "icon": "box", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/editor/simple-editor", "title": "Simple Editor", "icon": "box", "type": "link" },
                    { "order": 999,"path": "/editor/ck-editor", "title": "Ck Editor", "icon": "box", "type": "link" }
                    ]
                }),
        
                menu.push({
                    "order": 999,"title": "Users", "icon": "users", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/users/profile", "title": "Users Profile", "type": "link" },          
                    { "order": 999,"path": "/users/edit", "title": "Users Edit", "type": "link" },
                    { "order": 999,"path": "/users/cards", "title": "Users Cards", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"path": "/app/calendar", "title": "Calendar", "icon": "calendar", "type": "link", "bookmark": true
                }),
                menu.push({
                    "order": 999,"title": "Blog", "icon": "edit", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/blog/details", "title": "Blog Details", "type": "link" },          
                    { "order": 999,"path": "/blog/single", "title": "Blog Single", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"path": "/app/email", "title": "Email", "icon": "mail", "type": "link", "bookmark": true
                }),
                menu.push({
                    "order": 999,"path": "/app/chat", "title": "Chat", "icon": "message-square", "type": "link", "bookmark": true
                }),
                menu.push({
                    "order": 999,"path": "/pages/social-app", "title": "Social App", "icon": "chrome", "type": "link"
                }),
                menu.push({
                    "order": 999,"title": "Job Search", "icon": "user-check", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/job/list", "title": "List View", "type": "link" },
                    { "order": 999,"path": "/job/details/1", "title": "Job Details", "type": "link" },
                    { "order": 999,"path": "/job/apply/1", "title": "Apply", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Learning", "icon": "layers", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/learning/list", "title": "Learning List", "type": "link" },          
                    { "order": 999,"path": "/learning/details/1", "title": "Detailed Course", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"path": "/pages/faq", "title": "FAQ", "icon": "help-circle", "type": "link"
                }),
                menu.push({
                    "order": 999,"path": "/knowledgebase", "title": "Knowledgebase", "icon": "database", "type": "link"
                }),
                menu.push({
                    "order": 999,"path": "/pages/support", "title": "Support Ticket", "icon": "headphones", "type": "link"
                }),
                menu.push({
                    "order": 999,"path": "/app/todo", "title": "Todo", "icon": "mic", "type": "link"
                }),
                menu.push({
                    "order": 999,"path": "/app/firebase-todo", "badgeType": "danger", "badgeValue": "hot", "title": "Firebase-Todo", "icon": "mic", "type": "link"
                }),
                menu.push({
                    "order": 999,"title": "Ecommerce", "icon": "shopping-bag", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/ecommerce/product", "title": "Product", "type": "link" },          
                    { "order": 999,"path": "/ecommerce/details/1", "title": "Product Details", "type": "link" },
                    { "order": 999,"path": "/ecommerce/cart", "title": "Cart", "type": "link" },
                    { "order": 999,"path": "/ecommerce/wishlist", "title": "Wishlist", "type": "link" },
                    { "order": 999,"path": "/ecommerce/checkout", "title": "Checkout", "type": "link" },
                    { "order": 999,"path": "/ecommerce/invoice", "title": "Invoice", "type": "link" },
                    { "order": 999,"path": "/ecommerce/order/history", "title": "Order Details", "type": "link" },
                    { "order": 999,"path": "/ecommerce/payment/details", "title": "Payment Details", "type": "link" }
                    ]
                }),
                menu.push({
                    "order": 999,"path": "/pages/pricing", "title": "Pricing", "icon": "dollar-sign", "type": "link"
                }),
                menu.push({
                    "order": 999,"path": "/pages/sample-page", "title": "Sample page", "icon": "file", "type": "link"
                }),
                menu.push({
                    "order": 999,"path": "/pages/search", "title": "Search Pages", "icon": "search", "type": "link"
                }),
                menu.push({
                    "order": 999,"title": "Error Page", "icon": "alert-octagon", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/error-400", "title": "Error 400", "type": "extTabLink" },          
                    { "order": 999,"path": "/error-401", "title": "Error 401", "type": "extTabLink" },
                    { "order": 999,"path": "/error-403", "title": "Error 403", "type": "extTabLink" },
                    { "order": 999,"path": "/error-404", "title": "Error 404", "type": "extTabLink" },
                    { "order": 999,"path": "/error-500", "title": "Error 500", "type": "extTabLink" },
                    { "order": 999,"path": "/error-503", "title": "Error 503", "type": "extTabLink" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Authentication", "icon": "unlock", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/auth/login", "title": "Login Simple", "type": "extTabLink" },          
                    { "order": 999,"path": "/authentication/login/image", "title": "Login with Bg Image", "type": "extTabLink" },
                    { "order": 999,"path": "/authentication/login/video", "title": "Login with Bg video", "type": "extTabLink" },
                    { "order": 999,"path": "/auth/register", "title": "Register Simple", "type": "extTabLink" },
                    { "order": 999,"path": "/authentication/register/image", "title": "Register with Bg Image", "type": "extTabLink" },
                    { "order": 999,"path": "/authentication/register/video", "title": "Register with Bg video", "type": "extTabLink" },
                    { "order": 999,"path": "/authentication/unlockuser", "title": "Unlock User", "type": "extTabLink" },
                    { "order": 999,"path": "/authentication/forgetpassword", "title": "Forget Password", "type": "extTabLink" },
                    { "order": 999,"path": "/authentication/resetpassword", "title": "Reset Password", "type": "extTabLink" }
                    ]
                }),
                menu.push({
                    "order": 999,"title": "Coming Soon", "icon": "briefcase", "type": "sub", "active": false, "children": [
                    { "order": 999,"path": "/comingsoon/comingsoon-simple", "title": "Coming Simple", "type": "extTabLink" },          
                    { "order": 999,"path": "/comingsoon/comingsoon-image", "title": "Coming with Bg Image", "type": "extTabLink" },
                    { "order": 999,"path": "/comingsoon/comingsoon-video", "title": "Coming with Bg video", "type": "extTabLink" }
                    ]
                }),
                menu.push({
                    "order": 999,"path": "/maintenance", "title": "Maintenance", "icon": "settings", "type": "extTabLink"
                })
            }*/
                

            var accesos = JSON.parse(localStorage.accesos)

            var mostreDashboardAgent = false
            var mostreDashboardBilling = false
            var mostreDashboardCobranza = false
            var existe_timer = false;

            var ajustes_children = []
            var menu = []
    
            accesos.forEach(x => {

                console.log("x", x);
    
                //// **** COMPANY **** ////
                
                if (x.model == "case" && mostreDashboardAgent == false) {
                    mostreDashboardAgent = true

                    menu.push({
                        order: 0, title: "Dashboard", icon: "pie-chart", type: "sub", active: false, 
                        /*children: [
                            { order: 0, path: "/dashboard/agent", title: "Dashboard Agente", type: "link" }
                        ]*/
                    })

                }

                if (x.model == "invoice" && x.permission == "management" && mostreDashboardBilling == false) {
                    mostreDashboardBilling = true

                    if (mostreDashboardAgent == false) {
                        menu.push({ order: 0, title: "Dashboard", icon: "pie-chart", type: "sub", active: false,
                            /*children: [
                                { order: 0, path: "/dashboard/billing", title: "Dashboard Facturación", type: "link" },
                            ] */
                        },)
                    } else {
                        menu.forEach(element => {
                            if (element.title == "Dashboard") {
                                //element.children.push({ order: 1,path: "/dashboard/billing", title: "Dashboard Facturación", type: "link", active: false })
                            }
                        });
                    }
                }

                if (x.model == "security") {
                    main_menu.push({ order: 9, title: "Ajustes", icon: "settings", type: "sub", path: "/settings/list", active: false })
                }
                
                
                /*if (x.model == "collection" && x.permission == "management" && mostreDashboardCobranza == false) {
                    mostreDashboardCobranza = true
                    if (mostreDashboardBilling == false && mostreDashboardAgent == false) {
                    menu.push({ order: 0, title: "Dashboard", icon: "pie-chart", type: "sub", active: false,
                    children: [
                        { order: 2,path: "/dashboard/cobranza", title: "Dashboard Cobranzas", type: "link", active: false },
                        ] 
                    },)
                    } else {
                    menu.forEach(element => {
                        if (element.title == "Dashboard") {
                            element.children.push({ order: 2,path: "/dashboard/collections", title: "Dashboard Cobranzas", type: "link", active: false })
                        }
                    });
                    }
                }*/
        
                
        
                //// **** CAMPANIA **** ////
        
                /*if (x.model == "company") {
                    menu.push({ order: 3, title: "Campañas", icon: "home", type: "sub", active: false, //business_center
                    children: [
                        { order: 0,path: "/Campanias", title: "Gestión de Campañas", type: "link", active: false },
                    ]
                    },)
                }*/
        
                //// **** CASE **** ////
        
                if (x.model == "case") {
        
                    var existe = false;
                    
                    menu.forEach(element => {
                        if (element.title == "Casos") {
                            existe = true
            
                            if (x.permission == "management") {
                                //element.children.push({ order: 0,path: "/case/list", title: "Gestión de Casos", type: "link", active: false })
                                //element.children.push({ order: 2, title: "Parámetros", type: "sub", active: false, 
                                /*children: [
                                    {path: "/case/management_results", title: "Resultados de Gestión", type: "link", active: false },
                                    {path: "/case/forms_configuration", title: "Configuración de Formularios", type: "link", active: false },
                                    ]   
                                })*/
                            } 
                            else if (x.permission == "supervision" || x.permission == "revision" || x.permission == "readonly") {
                                //element.children.push({ order: 0,path: "/case/list", title: "Gestión de Casos", type: "link" , active: false })
                            }
                            else if (x.permission == "attention") {
                                //element.children.push({ order: 1,path: "/case/mylist", title: "Mis Casos", type: "link", active: false })
                            }
                        }

                        if (element.title == "Reportes") {
                            if (x.permission == "management") {
                                //element.children.push({ order: 0,path: "/report/list", title: "Diseñador de Reportes", type: "link", active: false })
                            } 
                        }
                    });
        
                    if (!existe) {

                        if (x.permission == "management") {
                            menu.push({ order: 2, title: "Casos", icon: "inbox", type: "sub", active: false,
                                /*children: [
                                    { order: 0,path: "/case/list", title: "Gestión de Casos", type: "link", active: false },
                                    { order: 2, title: "Parámetros", type: "sub", active: false, 
                                    children: [
                                        { order: 0,path: "/case/management_results", title: "Resultados de Gestión", type: "link", active: false },
                                    ]   
                                    }
                                ] */
                            })
                            menu.push({ order: 10, title: "Reportes", icon: "bar-chart-2", type: "sub", active: false,
                                /*children: [
                                    { order: 0,path: "/report/list", title: "Diseñador de Reportes", type: "link", active: false },
                                    { order: 1,path: "/report/viewer", title: "Ver Reportes", type: "link", active: false },
                                ] */
                            })
                        } 
                        else if (x.permission == "supervision" || x.permission == "revision" || x.permission == "readonly") {
                            menu.push({ order: 2, title: "Casos", icon: "inbox", type: "sub", active: false,
                                /*children: [
                                    { order: 0,path: "/case/list", title: "Gestión de Casos", type: "link", active: false },
                                ] */
                            })
                            menu.push({ order: 10, title: "Reportes", icon: "bar-chart-2", type: "sub", active: false,
                                /*children: [
                                    { order: 1,path: "/report/viewer", title: "Ver Reportes", type: "link", active: false },
                                ] */
                            })
                        }
                        else if (x.permission == "attention") {
                            menu.push({ order: 2, title: "Casos", icon: "inbox", type: "sub", active: false,
                                /*children: [
                                    { order: 1,path: "/case/mylist", title: "Mis Casos", type: "link", active: false },
                                ] */
                            })
                            menu.push({ order: 10, title: "Reportes", icon: "bar-chart-2", type: "sub", active: false,
                                /*children: [
                                    { order: 1,path: "/report/viewer", title: "Ver Reportes", type: "link", active: false },
                                ] */
                            })
                        }
                    }
                    
                }

                //// **** TIMES **** ////
        
                /*if (x.model == "case" && existe_timer == false) {

                    existe_timer = true
                    menu.push({ order: 3, title: "Tiempos", icon: "clock", type: "sub", active: false,
                    children: [
                        { order: 0,path: "/time/list", title: "Mis Tiempos", type: "link", active: false }
                    ] 
                    })
                }*/

                //// **** RATE **** ////
        
                if (x.model == "rate") {
                    menu.push({ order: 4, title: "Tarifarios", icon: "dollar-sign", type: "sub", active: false,
                    /*children: [
                        { order: 0,path: "/rate/list", title: "Gestión de Tarifarios", type: "link", active: false }
                    ] */
                    })
                }
        
                //// **** INVOICE **** ////
                
                console.log("x.model", x.model);

                if (x.model == "invoice") {

                    console.log("x.permission", x.permission);

                    if (x.permission != "readonly") {

                        console.log("agrego el elemento al menu");

                        //menu.push({ order: 5, title: "Facturas", icon: "file", type: "sub", active: false,
                        /*children: [
                            { order: 0,path: "/invoice/list", title: "Gestión de Facturas", type: "link", active: false }
                        ] */
                        //})

                        main_menu.push({ order: 4, title: "Facturas", icon: "file", type: "sub", path: "/invoice/list", active: false })
                    }
                }
        
                //// **** CONTACT **** ////
        
                if (x.model == "contact") {
                    if (x.permission != "readonly") {
                        main_menu.push({ order: 6, title: "Contactos", icon: "user", type: "sub", path: "/contact/list", active: false })
                    }
                    
                    //menu.push({ order: 6, title: "Contactos", icon: "users", type: "sub", active: false,
                    /*children: [
                        { order: 0,path: "/contact/list", title: "Gestión de Contactos", type: "link", active: false },
                    ] */
                    //})
                }
        
                //// **** PRODUCT **** ////
        
                if (x.model == "product") {
                    if (x.permission != "readonly") {
                        main_menu.push({ order: 7, title: "Servicios", icon: "grid", type: "sub", path: "/service/list", active: false })
                    }
                    //menu.push({ order: 7, title: "Servicios", icon: "grid", type: "sub", active: false,
                    /*children: [
                        { order: 0,path: "/service/list", title: "Gestión de Servicios", type: "link", active: false },
                    ] */
                    //})
                }

                //// **** PROJECT **** ////
        
                if (x.model == "project") {
                    menu.push({ order: 8, title: "Proyectos", icon: "command", type: "sub", active: false,
                    /*children: [
                        { order: 0,path: "/project/list", title: "Gestión de Proyectos", type: "link", active: false },
                        { order: 1,path: "/project_client/list", title: "Gestión de Clientes", type: "link", active: false },
                    ] */
                    })
                }
        
                //// **** INFRA **** ////
        
                if (x.model == "infra") {
                    menu.push({ order: 9, title: "Infraestructura", icon: "server", type: "sub", active: false,
                        /*children: [
                            { order: 0,path: "/infra/datacenter/list", title: "Datacenters", type: "link", active: false },
                            { order: 1,path: "/infra/virtualizer_server/list", title: "Servidores Virtualizadores", type: "link", active: false },
                            { order: 2,path: "/infra/server/list", title: "Servidores", type: "link", active: false },
                            { order: 3,path: "/infra/virtual_env/list", title: "Ambientes Virtuales", type: "link", active: false },
                            { order: 4,path: "/infra/sw/list", title: "Software", type: "link", active: false },
                            { order: 5, title: "Parámetros", type: "sub", active: false, 
                                children: [
                                    {path: "/infra/server_states/list", title: "Estados de Servidores", type: "link", active: false },
                                    {path: "/infra/virtual_env_states/list", title: "Estados de Ambientes Virtuales", type: "link", active: false },
                                    {path: "/infra/software_states/list", title: "Estados de Software", type: "link", active: false }
                                ]   
                            }
                        ] */
                    })
                }

                //// **** COBRANZA **** ////
        
                /*if (x.model == "collection") {
                    menu.push({ order: 2, title: "Cobranzas", icon: "home", type: "sub", active: false, //business_center
                    children: [
                        { order: 0,path: "/Cuota", title: "Gestión de Cuotas", type: "link", active: false },
                        { order: 1,path: "/Pago", title: "Gestión de Pagos", type: "link", active: false },
                        { order: 2,path: "/MisCobranzas", title: "Mis Cobranzas", type: "link", active: false },
                        { order: 3,path: "/SupervisionCobranza", title: "Supervision", type: "link", active: false },
                        { order: 4,path: "/ReportesCobranza", title: "Reportes", type: "link", active: false },
                        { order: 5, title: "Parámetros", type: "sub", active: false, 
                        children: [
                            { order: 0,path: "/EstadoCobranza", title: "Estado de Cobranzas", type: "link", active: false },
                            { order: 1,path: "/EstadoCuota", title: "Estado de Cuotas", type: "link", active: false },
                        ]   
                        }
                    ]
                    },)
                }*/
        
                //// **** INTEGRATION **** ////
        
                /*if (x.model == "integration" && x.permission == "management") {
                    menu.push({ order: 11, title: "Integraciones", icon: "box", type: "sub", active: false,
                        children: [
                            { order: 0,path: "/google_drive/list", title: "Google Drive", type: "link", active: false },
                            { order: 1,path: "/google_drive/list", title: "One Drive", type: "link", active: false },
                            { order: 2,path: "/google_drive/list", title: "DropBox", type: "link", active: false },
                            { order: 3,path: "/google_drive/list", title: "AWS SFTP", type: "link", active: false },
                            { order: 4,path: "/google_drive/list", title: "File Share", type: "link", active: false }
                        ]  
                    })
                }*/
        
                //// **** SECURITY **** ////

                //// **** COMPANY **** ////
        
                /*if (x.model == "company") {
                    menu.push({ order: 1, title: ( (environment_name == 'zunigeaaa')?'Empresa':'Grupo de trabajo'), icon: "briefcase", type: "sub", active: false, //business_center
                    children: [
                        { order: 0, path: "/company/list", title: ( (environment_name == 'zunigeaaa')?'Gestión de Empresas':'Gestión de Grupos de Trabajo'), type: "link", active: false },
                    ] 
                    },)
                }*/

                

                /*if (x.model == "company") {
                    ajustes_children.push({ order: 1, title: 'Grupos de trabajo', icon: "briefcase", type: "link", path: "/company/list", active: false })
                }

                if (x.model == "integration") {
                    ajustes_children.push({ order: 4,path: "/google_drive/list", title: "Google Drive", type: "link", active: false })
                }

                if (x.model == "security") {
                    ajustes_children.push({ order: 2,path: "/user/list", title: "Usuarios", type: "link", active: false })
                    ajustes_children.push({ order: 3,path: "/rol/list", title: "Roles", type: "link", active: false })
                }

                if (x.model == "environment") {
                    ajustes_children.push({ order: 4,path: "/environment/list", title: "Ambientes", type: "link", active: false })
                }*/



        
                /*if (x.model == "    ") {
                    menu.push({ order: 13, title: "Seguridad", icon: "lock", type: "sub", active: false,
                        children: [
                            //{ order: 0,path: "/user/ad", title: "Active Directory", type: "link", active: false },
                            //{ order: 1,path: "/user/sso", title: "Single Sign-On", type: "link", active: false },
                            { order: 2,path: "/user/list", title: "Usuarios", type: "link", active: false },
                            { order: 3,path: "/rol/list", title: "Roles", type: "link", active: false },
                            //{ order: 4,path: "/user/audit", title: "Auditoría", type: "link", active: false }
                            
                        ]  
                    })
                }
        
                //// **** ENVIRONMENT **** ////
        
                if (x.model == "environment") {
                    menu.push({ order: 99, title: "Seguridad", icon: "globe", type: "sub", active: false,
                    children: [
                        { order: 0,path: "/environment/list", title: "Ambientes", type: "link", active: false }
                    ]  
                    })
                }*/
  
          });

          //menu.push({ order: 13, title: "Ajustes", icon: "settings", type: "sub", active: false, /*children: ajustes_children*/ })

          
  
          /*menu.forEach(element => {
            if (element.children) {
                element.children.sort(function(a, b){return a.order-b.order})
            }
          });*/

          //localStorage.MainMenu = JSON.stringify(menu);

          //menu_data = newMenu;

          //--callback(menu)

        } else {
            console.log("no cargo menu")
        }
      }
}

export default new Auth();
